import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

interface ChatScrollButtonProps {
  onClick: () => void;
}

export const ChatScrollButton = ({ onClick }: ChatScrollButtonProps) => {
  return (
    <div className="px-4 py-2 border-t bg-background">
      <Button
        variant="outline"
        size="sm"
        className="w-full"
        onClick={onClick}
      >
        <ArrowDown className="w-4 h-4 mr-2" />
        New Messages Below. Scroll To Bottom
      </Button>
    </div>
  );
};
